import classNames from 'classnames';
import React from 'react';

import css from './IconYourOwnFarm.module.css';

const IconYourOwnFarm = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 160 160"
      enableBackground="new 0 0 160 160"
    >
      <path
        d="m139.5 52.9 4.8-4.2c1-.9 1.5-2.3 1.1-3.7-.4-1.3-1.4-2.4-2.8-2.7l-6.2-1.3c-8.1-1.7-16.7.5-23 6v-4.7c0-2-1.6-3.7-3.7-3.7-2 0-3.7 1.6-3.7 3.7v8.3c-2.3.2-4.5.6-6.8 1.3-4.2 1.4-7.8 3.7-10.7 6.7-2.4-.6-4.9-.8-7.4-.7l.9-.4c1.3-.6 2.1-1.8 2.1-3.2.1-1.4-.7-2.7-1.9-3.4l-5.6-3.1c-7.3-4-16.2-4.4-23.9-.9h-.1v-6.7c0-2-1.6-3.7-3.7-3.7s-3.7 1.6-3.7 3.7v4c-6-4.7-14-6.7-21.6-5.2l-6.2 1.2c-1.4.3-2.5 1.3-2.8 2.6-.4 1.3 0 2.8 1.1 3.7l4.7 4.3c2.6 2.4 5.7 4.1 8.9 5.3-2.6 2.7-4.7 5.9-6.1 9.4H18c-2 0-3.7 1.6-3.7 3.7v50.2c0 2 1.6 3.7 3.7 3.7h121.5c2 0 3.7-1.6 3.7-3.7v-50c0-2-1.6-3.7-3.7-3.7h-7.1c-1.3-2.5-2.9-4.8-4.8-6.8 4.5-1 8.5-3 11.9-6zm-3.5 63H21.9V73.1h6.5v10.4c0 2 1.6 3.7 3.7 3.7H126c2 0 3.7-1.6 3.7-3.7V73.1h6.5v42.8zM41.2 50.3c-5.3.8-10.7-.7-14.9-4.1 5.3-.7 10.7.8 14.9 4.1zm50 17.1c4.8 2.4 8.4 6.5 10.1 11.6.1.3.2.6.2.9H76.2c.7-4.2.4-8.7-1-13 0-.1 0-.1-.1-.2.3-.1.5-.2.8-.3 2.1-.7 4.3-1.1 6.5-1.1 3 0 6 .7 8.8 2.1zM56.8 53.3c5-2 10.6-1.8 15.4.5-4.9 2.1-10.5 1.9-15.4-.5zm-17.1 4.5c1.3-.1 2.6-.2 3.9-.5l3.9-.8 4.9 2.7c3.7 2.1 7.9 3.1 12.1 3.2 1.6 1.9 2.9 4.1 3.7 6.6 1.2 3.6 1.3 7.2.5 10.7h-33V69.4c0-2-1.6-3.7-3.7-3.7h-.4c1.8-3.3 4.6-6 8.1-7.9zm82.5 11.6v10.4h-13.1c-.2-1.1-.5-2.1-.8-3.2-2.1-6.3-6.4-11.5-12.1-14.9 1.6-1.2 3.4-2.1 5.4-2.8 2.1-.7 4.3-1.1 6.5-1.1 3.1 0 6.1.7 8.9 2.1 2.9 1.4 5.4 3.5 7.2 6.1-1.2.7-2 1.9-2 3.4zm11.7-21.3c-4.2 3.3-9.7 4.8-14.9 3.9 4.1-3.3 9.6-4.8 14.9-3.9z"
        fill="#011602"
      />
      <ellipse cx="37.9" cy="100.2" rx="4.1" ry="4.2" fill="#011602" />
      <ellipse cx="120" cy="100.2" rx="4.1" ry="4.2" fill="#011602" />
    </svg>
  );
};

export default IconYourOwnFarm;
